import { 
  FaCar, 
  FaGavel, 
  FaFileAlt, 
  FaSearchPlus,
  FaUserCheck,
  FaDollarSign,
  FaHeadset
} from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaCar className="w-8 h-8" />,
      title: "Exkluzivní nabídka amerických vozidel",
      description: "Na AMA-Europe najdete vozy, které jinde nenajdete. Ať už toužíte po legendárních muscle cars, luxusních SUV, nebo praktických pick-upech, nabízíme širokou škálu automobilů, které vám umožní splnit si svůj sen. Každé auto má svůj jedinečný příběh a je připraveno najít svého nového majitele."
    },
    {
      icon: <FaGavel className="w-8 h-8" />,
      title: "Živé aukce s možností výhodného nákupu",
      description: "Naše aukce nejsou jen obchod, ale také vzrušující zážitek. Auta se prodávají za férové a často velmi výhodné ceny, díky čemuž můžete získat mnohem víc za své peníze. Aukce startují, jakmile je přihlášen dostatek účastníků, takže se můžete těšit na skutečnou akční atmosféru plnou napětí."
    },
    {
      icon: <FaFileAlt className="w-8 h-8" />,
      title: "Transparentnost díky přístupu k Carfaxu",
      description: "Kupovat vůz bez informací? To není náš styl. Po registraci do aukce získáte přístup k detailním Carfax zprávám. Ty zahrnují informace o nehodách, počtu předchozích majitelů a servisní historii. Díky tomu můžete udělat informované rozhodnutí a přihazovat s klidným svědomím."
    },
    {
      icon: <FaSearchPlus className="w-8 h-8" />,
      title: "Možnost osobní prohlídky vozidel",
      description: "Věříme, že nejdůležitější je vědět, co kupujete. Proto vám nabízíme možnost prohlédnout si vozidla osobně ještě před samotnou aukcí. Vidíte vše na vlastní oči a máte jistotu, že kupujete to, co skutečně chcete – žádná překvapení vás nečekají."
    },
    {
      icon: <FaUserCheck className="w-8 h-8" />,
      title: "Jednoduchý a férový registrační proces",
      description: "Připojit se do aukce je snadné a transparentní. Každá aukce má jasně uvedený registrační poplatek, který stačí uhradit. Jakmile jste zaregistrováni, můžete začít přihazovat na své vybrané auto. Žádné skryté poplatky, žádná složitá pravidla – jen férový přístup."
    },
    {
      icon: <FaDollarSign className="w-8 h-8" />,
      title: "Auta za skvělé ceny",
      description: "Naše platforma je ideální pro ty, kteří chtějí pořídit americký vůz za atraktivní cenu. Díky soutěžnímu formátu aukcí často získáte vozidlo za mnohem nižší částku, než byste zaplatili jinde. Výhodné nabídky čekají na každého!"
    },
    {
      icon: <FaHeadset className="w-8 h-8" />,
      title: "Profesionální a přátelský servis",
      description: "Jsme tu, abychom vám poskytli nejen auta, ale i podporu po celou dobu vaší cesty aukcí. Náš tým vám rád odpoví na otázky a provede vás procesem registrace, aukce i převzetí vozu. Jsme vaším partnerem, na kterého se můžete spolehnout."
    }
  ];

  return (
    <div className="bg-gray-900 py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Proč zvolit <span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">AMA-Europe?</span>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-gray-800 rounded-lg p-6 backdrop-filter backdrop-blur-lg bg-opacity-50
                          flex flex-col items-center justify-center ${index === 6 ? 'col-span-1 md:col-start-2' : ''}`} // Poslední karta ve středním sloupci
            >
              <div className="flex items-center justify-center w-16 h-16 mb-6 rounded-full
                            bg-gradient-to-r from-blue-600 to-purple-600 mx-auto">
                {feature.icon}
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4 text-center">
                {feature.title}
              </h3>
              
              <p className="text-gray-300 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features; 